import { numberFormatter } from "utils/helpers";

interface IResultsCountAndSeeMoreProps {
    seeMore: () => string;
    total: number;
    count?: number;
    start?: number;
    stop?: number;
}

export const ResultsCountAndSeeMore = (props: IResultsCountAndSeeMoreProps): JSX.Element => {
    const { seeMore, total = 0, count = 0, start = 0, stop = 0 } = props;
    return (
        <div className="font_size--medium">
            {start || stop ? `${numberFormatter(start + 1)}-${numberFormatter(stop)}` : numberFormatter(count)}/
            {numberFormatter(total)} results&nbsp;
            <a
                href={seeMore()}
                target="_blank"
                rel="noopener noreferrer"
                className="ai_bubble_footer_count cursor-hand pl-2"
            >
                See full results <img src="https://content.harstatic.com/media/icons/external-link-blue.svg" alt="External Link" style={{ width: 12 }}></img>
            </a>
        </div>
    )
}
